import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { ProductRedemptionStatus } from '@sxm-de/dev-kits/web-sdk/types';
import { getPartnerEntitlement } from '../helpers/get-partner-entitlement';

interface GetProductRedemptionStatusFnPayload {
    subscriptionId: string;
    productId: string;
}

export type GetProductRedemptionStatusFn = (
    payload: GetProductRedemptionStatusFnPayload,
) => Promise<ProductRedemptionStatus>;

export function initGetProductRedemptionStatusFn({
    dependencies,
}: DomainInitPayload): GetProductRedemptionStatusFn {
    return async ({
        subscriptionId,
        productId,
    }: GetProductRedemptionStatusFnPayload) => {
        try {
            const entitlement = await getPartnerEntitlement(
                { subscriptionId, productId },
                dependencies,
            );

            if (entitlement) {
                if (entitlement.status.toLowerCase() === 'pending') {
                    return {
                        status: 'NotRedeemed',
                    };
                } else {
                    return {
                        status: 'Redeemed',
                    };
                }
            } else {
                throw new Error('SUBSCRIPTION_PRODUCT_NOT_FOUND');
            }
        } catch (error: any) {
            if (error?.message === 'SUBSCRIPTION_PRODUCT_NOT_FOUND') {
                throw error;
            } else {
                throw new Error('SYSTEM');
            }
        }
    };
}
